import * as angular from 'angular';

interface IModalScope extends angular.IScope {
    size: string;
}

class ModalDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';
    readonly scope = {
        heading: '@?',
        size: '@?',
        closable: '=?',
        contentClass: '@?'
    };

    readonly template = `
        <div
            class="fc-modal reveal {{ size }}"
            ng-class="{ 'fc-modal-has-heading': !!heading }"
            data-reveal
            data-animation-in="fade-in"
            data-animation-out="fade-out"
            data-close-on-esc="{{ closable !== false ? 'true' : 'false' }}"
            data-close-on-click="{{ closable !== false ? 'true' : 'false' }}"
        >
            <div ng-if="heading || closable" class="fc-modal-header">
                <div layout="row" layout-align="space-between center">
                    <div class="fc-modal-heading">{{ heading }}</div>
                    <fc-icon-button
                        ng-if="closable !== false"
                        class="fc-modal-close"
                        invariant="close"
                        close="true"
                    ></fc-icon-button>
                </div>
            </div>
            <div class="fc-modal-content {{ contentClass }}" ng-transclude></div>
        </div>
    `;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(scope: IModalScope): void {
        scope.size = scope.size || 'small';
    }
}

const ModalDirectiveFactory: angular.IDirectiveFactory = () => new ModalDirective();

export { ModalDirectiveFactory };
